<template>
  <div>
    <WebhookDetail type="new" :submitting="submitting" @submit="submit" />
  </div>
</template>

<script>
import { helper } from '@core/mixins/helper';
import WebhookDetail from '@/views/pages/web-hooks/WebhookDetail.vue';
import useService from '@/auth/service/useService';

export default {
  components: {
    WebhookDetail
  },
  mixins: [helper],

  data() {
    return {
      submitting: false
    };
  },

  methods: {
    submit(data) {
      const requestData = {
        ...data
      };

      this.submitting = true;
      useService.webhookService
        .createWebhook(requestData)
        .then(response => {
          this.$router.push({ name: 'web_hook_list' });
          this.showSuccessMessage(
            `${response.message || this.$t('Create Webhook Success Message')}`
          );
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>
